export type Industry = {
    name: string;
    slug: string;
    termCode: string; // Add NAICS code for structured data
    keywords: string[];
};

export const CAREERS = {
  "thuc-tap-sinh-ky-nang": [
    "Ngư nghiệp",
    "Nông Nghiệp",
    "Thực phẩm",
    "Sản xuất, dịch vụ tổng hợp",
    "Cơ khí, kim loại",
    "Xây dựng",
    "May mặc"
  ],
  "ky-nang-dac-dinh": [
    "Ngư nghiệp",
    "Nông nghiệp",
    "Nhà hàng",
    "Thực phẩm",
    "Sản xuất, dịch vụ tổng hợp",
    "Điện, điện tử",
    "Chế tạo Vật liệu",
    "Cơ khí, chế tạo máy",
    "Ô tô",
    "Hàng không",
    "Vận tải",
    "Xây dựng",
    "Vệ sinh toà nhà",
    "Lưu trú, khách sạn",
    "Điều dưỡng"
  ],
  "ky-su-tri-thuc": [
    "Nông lâm ngư nghiệp",
    "Thực phẩm",
    "Sản xuất, chế tạo, công nghệ",
    "Cơ khí, máy móc",
    "Công nghệ ô tô",
    "Vận chuyển hàng hoá",
    "Xây dựng",
    "Khách sạn, lưu trú",
    "Y tế, điều dưỡng",
    "Kinh doanh, kinh tế",
    "Tài chính, kế toán, bảo hiểm",
    "Báo chí, truyền thông, marketing",
    "Công nghệ thông tin",
    "Nghiên cứu, phân tích",
    "Giáo dục, đào tạo",
    "Hành chính, văn phòng",
    "Pháp lý",
    "Nghệ thuật, nghệ sĩ",
    "Thể dục thể thao",
    "Nghề có kỹ năng chuyên nghiệp",
    "Việc làm bán chuyên nghiệp"
  ]
}
export const industriesByJobType: { [key: string]: Industry[] } = {
    'thuc-tap-sinh-ky-nang': [
      { name: 'Ngư nghiệp', slug: 'ngu-nghiep', termCode: '11411', keywords: [
          'Câu cá ngừ cần và dây',
          'Câu mực',
          'Câu tôm, cua bằng lồng',
          'Đánh cá dây câu dài',
          'Đánh cá lưới kéo',
          'Đánh cá lưới rê',
          'Đánh cá lưới sào',
          'Đánh cá lưới thả',
          'Đặt lưới đánh cá',
          'Nuôi sò điệp'
      ] },
      { name: 'Nông nghiệp', slug: 'nong-nghiep', termCode: '111', keywords: [
          'Chăn nuôi bò',
          'Chăn nuôi bò sữa',
          'Chăn nuôi gà',
          'Chăn nuôi lợn',
          'Nhặt trứng gà',
          'Nông nghiệp chăn nuôi',
          'Nông nghiệp trồng trọt',
          'Thu hoạch bắp cải',
          'Thu hoạch cà chua',
          'Thu hoạch dâu tây',
          'Thu hoạch hoa',
          'Thu hoạch hoa quả',
          'Thu hoạch rau củ',
          'Trồng cây ăn quả',
          'Trồng nấm',
          'Trồng nấm công nghệ cao',
          'Trồng rau củ',
          'Trồng trọt nhà kính'
      ] },
      { name: 'Thực phẩm', slug: 'thuc-pham', termCode: '311', keywords: [
          'Bánh gạo',
          'Bánh kẹo',
          'Bánh ngọt',
          'Bếp viện',
          'Chế biến cá',
          'Chế biến đồ ăn sẵn',
          'Chế biến gia cầm',
          'Chế biến sushi',
          'Chế biến thịt bò, lợn',
          'Chế biến thuỷ sản sống',
          'Chiết xuất thuỷ sản',
          'Cơm hộp',
          'Cơm nắm',
          'Cửa hàng siêu thị',
          'Đậu hũ',
          'Đồ ăn kèm',
          'Đồ konbini',
          'Đóng gói bánh kẹo',
          'Đóng gói cafe',
          'Đóng gói gạo',
          'Đóng gói rau',
          'Đóng gói rau củ',
          'Đóng gói rong biển',
          'Đóng gói thanh cua',
          'Đóng hộp thực phẩm',
          'Gia công đồ ăn liền',
          'Giăm bông, xúc xích...',
          'Há cảo',
          'Làm bánh kẹo',
          'Mỳ tôm',
          'Salad',
          'Sản xuất bánh mì',
          'Sản xuất dưa muối',
          'Sản xuất mắm cá',
          'Sản xuất mỳ',
          'Siêu thị',
          'Tẩm ướp thuỷ sản',
          'Thái cá sashimi',
          'Thịt bò',
          'Thịt gà',
          'Thịt lợn',
          'Thức ăn cơ sở y tế',
          'Thực phẩm',
          'Thực phẩm sữa',
          'Thực phẩm trứng',
          'Thuỷ sản gia công chế biến',
          'Thuỷ sản khô',
          'Thuỷ sản lên men',
          'Thuỷ sản sấy khô',
          'Thuỷ sản ủ muối',
          'Thuỷ sản xông khói'
      ] },
      { name: 'Sản xuất, dịch vụ tổng hợp', slug: 'san-xuat-dich-vu-tong-hop', termCode: '3261', keywords: [
          '(Khách sạn) Tiếp khách, quản lý vệ sinh',
          'Bảo dưỡng ô tô',
          'Bảo trì đường sắt',
          'Buồng phòng khách sạn',
          'Công việc cưa gỗ',
          'Điều dưỡng, hộ lý',
          'Dọn dẹp khoang hành khách',
          'Đóng gói',
          'Đóng gói công nghiệp',
          'Đóng gói mỹ phẩm',
          'Đóng sách',
          'Đúc gốm bằng áp lực',
          'Đúc khuôn cao su',
          'Đục lỗ hộp in',
          'Đúc nhựa',
          'Đúc nhựa cán xếp chồng',
          'Đục nhựa ép phun',
          'Đúc nhựa nén',
          'Đúc nhựa thổi định hình',
          'Đúc nhựa thổi phồng',
          'Gia công đồ gia dụng',
          'Gia công ép đùn cao su',
          'Gia công sản phẩm gỗ',
          'Gỗ ép',
          'Hàng hóa hàng không',
          'Hỗ trợ mặt đất máy bay',
          'In gốm',
          'In offset',
          'In ống đồng',
          'In vỏ bánh kẹo',
          'Kiểm tra linh kiện ô tô',
          'Kiểm tra sản phẩm nhựa',
          'Lắp ráp linh kiện ô tô',
          'Linh kiện ô tô',
          'Nặn gốm bằng bánh xoay',
          'Nhiên liệu rắn từ rác',
          'Sản xuất hộp bìa cứng',
          'Sản xuất hộp in',
          'Sản xuất hộp nhãn dán',
          'Sản xuất linh kiện',
          'Sản xuất pin năng lượng',
          'Sản xuất vải lanh',
          'Sửa chữa ô tô',
          'Thiết bị khí nén đường sắt',
          'Trộn và cán cao su',
          'Vật liệu composite nhiều lớp',
          'Vệ sinh phòng học',
          'Vệ sinh toà nhà',
          'Vệ sinh văn phòng'
      ] },
      { name: 'Cơ khí, kim loại', slug: 'co-khi-kim-loai', termCode: '332710', keywords: [
          'Bản mạch in',
          'Bảo trì máy móc',
          'Chế tạo kim loại tấm',
          'Chế tạo máy',
          'Cơ khí',
          'Cuộn dây máy điện quay',
          'Dập khuôn kim loại',
          'Điện',
          'Điện tử',
          'Đóng tàu',
          'Đúc',
          'Đúc gang',
          'Đúc khuôn',
          'Đúc khuôn buồng lạnh',
          'Đúc khuôn buồng nóng',
          'Đúc kim loại màu',
          'Ép dập kim loại',
          'Gia công cơ khí',
          'Gia công ép đùn',
          'Gia công kim loại - Tekko',
          'Gia công tinh',
          'Hàn',
          'Hàn bán tự động',
          'Hàn kết cấu',
          'Hàn khí',
          'Hàn khung thép',
          'Hàn tàu',
          'Hàn thủ công',
          'Hàn tủ điện',
          'Hàn xì',
          'Hoàn thiện dụng cụ nung chảy',
          'Hoàn thiện khuôn',
          'Hoàn thiện sản phẩm ép đùn',
          'Kiểm tra máy móc',
          'Lắp đặt điều hoà',
          'Lắp đặt máy móc',
          'Lắp đặt tủ lạnh',
          'Lắp ráp điện',
          'Lắp ráp điện tử',
          'Lắp ráp linh kiện bán dẫn',
          'Lắp ráp máy biến áp',
          'Lắp ráp thiết bị điện khí',
          'Lắp ráp thiết bị điện quay',
          'Lắp ráp thiết bị điện tử',
          'Lắp thiết bị đóng, mở',
          'Lắp tủ điện, tủ điều khiển',
          'Mạ điện',
          'Mạ kẽm nhúng nóng',
          'Máy sản xuất tấm kim loại',
          'Rèn',
          'Rèn bằng búa',
          'Sơn',
          'Sơn cầu thép',
          'Sơn công trình xây dựng',
          'Sơn kim loại',
          'Sơn phun',
          'Sử dụng máy phay',
          'Sử dụng máy tiện số',
          'Sử dụng máy tiện thường',
          'Thi công điện',
          'Thi công kết cấu thép',
          'Thiết kế bảng mạch in',
          'Vận hành máy',
          'Vận hành máy CNC',
          'Vận hành máy ép',
          'Vận hành máy ép nhựa',
          'Vận hành robot',
          'Xử lý điện hóa nhôm'
      ] },
      { name: 'Xây dựng', slug: 'xay-dung', termCode: '23', keywords: [
          'Bê tông',
          'Buộc thép',
          'Chống thấm',
          'Cốp pha công trình',
          'Dán tường',
          'Đổ bê tông áp lực',
          'Đổ nhựa đường',
          'Dựng giàn giáo',
          'Đường ống',
          'Đường ống điều hoà',
          'Đường ống nhà máy',
          'Đường ống nước',
          'Đường ống xây dựng',
          'Gia công đường ống',
          'Gia công khung thép',
          'Gia công khung thép trong xưởng',
          'Gia công sắt trong xưởng',
          'Gia công vật liệu đá',
          'Hàn khung thép trên cao',
          'Hoàn thiện nội thất',
          'Hoàn thiện sàn nhựa',
          'Hoàn thiện sàn thảm',
          'Hoàn thiện ván',
          'Hút nước ngầm công trình',
          'Khoan giếng máy dập',
          'Khoan giếng máy khoan',
          'Khung chắn toà nhà',
          'Lái máy ủi',
          'Lái máy xây dựng',
          'Lái máy xúc',
          'Lái máy xúc lật',
          'Lái xe lu',
          'Làm nền, móng',
          'Lắp bồn tắm',
          'Lắp đặt đường ống',
          'Lắp đặt lò nung-xây dựng',
          'Lắp đặt pin năng lượng',
          'Lắp điện lạnh, điều hòa',
          'Lắp ghép cốt thép',
          'Lát đá',
          'Lợp mái nhà',
          'Lợp ngói',
          'Mộc cốp pha',
          'Nội thất gỗ-xây dựng',
          'Ốp lát gạch',
          'Phá dỡ',
          'San lấp mặt bằng',
          'Sản xuất bê tông',
          'Sơn xây dựng',
          'Tấm kim loại kiến trúc',
          'Tấm kim loại ống gió',
          'Thi công dán tường',
          'Thi công lắp rèm',
          'Thi công móng thép',
          'Thợ mộc xây dựng',
          'Trát vữa',
          'Xây dựng tổng hợp'
      ] },
      { name: 'May mặc', slug: 'may-mac', termCode: '315', keywords: [
          'Chăn ga gối đệm',
          'Công việc trước kéo sợi',
          'Công việc trước khi dệt',
          'Dệt hoàn thiện',
          'Dệt kim máy sợi dọc',
          'Dệt may',
          'Gia công dệt',
          'Gia công sợi hỗn hợp',
          'Kéo sợi tinh',
          'May khăn mặt',
          'May mặc',
          'May quần áo',
          'May quần áo nam',
          'Nhuộm chỉ',
          'Nhuộm vải, đan len',
          'Quần áo phụ nữ, trẻ em',
          'Quấn sợi',
          'Sản xuất áo sơ mi',
          'Sản xuất đồ lót',
          'Sản xuất ghế ngồi ô tô',
          'Sản xuất máy dệt kim tròn',
          'Sản xuất tất',
          'Sản xuất thảm dệt',
          'Sản xuất thảm đục lỗ',
          'Sản xuất thảm nhung nổi',
          'Sản xuất vải bạt'
      ] }
    ],
    'ky-nang-dac-dinh': [
      { name: 'Ngư nghiệp', slug: 'ngu-nghiep', termCode: '11411', keywords: [
          'Nuôi trồng thủy sản',
          'Đánh bắt cá'
      ] },
      { name: 'Nông nghiệp', slug: 'nong-nghiep', termCode: '111', keywords: [
          'Chăn nuôi bò',
          'Chăn nuôi bò sữa',
          'Chăn nuôi gà',
          'Chăn nuôi lợn',
          'Nhặt trứng gà',
          'Trồng cây ăn quả',
          'Trồng hoa',
          'Trồng nấm',
          'Trồng rau củ quả trong nhà kính',
          'Trồng rau củ quả ngoài trời'
      ] },
      { name: 'Nhà hàng', slug: 'nha-hang', termCode: '722511', keywords: [
          'Chạy bàn',
          'Mua hàng',
          'Nấu bếp',
          'Nhà hàng',
          'Phụ bếp',
          'Quản lý',
          'Rửa bát',
          'Thu ngân'
      ] },
      { name: 'Thực phẩm', slug: 'thuc-pham', termCode: '311', keywords: [
          'Bánh gạo',
          'Bánh kẹo',
          'Bánh ngọt',
          'Bếp viện',
          'Chế biến cá',
          'Chế biến đồ ăn sẵn',
          'Chế biến gia cầm',
          'Chế biến sushi',
          'Chế biến thịt bò, lợn',
          'Chế biến thuỷ sản sống',
          'Chiết xuất thuỷ sản',
          'Cơm hộp',
          'Cơm nắm',
          'Cửa hàng siêu thị',
          'Đậu hũ',
          'Đồ ăn kèm',
          'Đồ konbini',
          'Đóng gói bánh kẹo',
          'Đóng gói cafe',
          'Đóng gói gạo',
          'Đóng gói rau',
          'Đóng gói rau củ',
          'Đóng gói rong biển',
          'Đóng gói thanh cua',
          'Đóng hộp thực phẩm',
          'Gia công đồ ăn liền',
          'Giăm bông, xúc xích...',
          'Há cảo',
          'Làm bánh kẹo',
          'Mỳ tôm',
          'Salad',
          'Sản xuất bánh mì',
          'Sản xuất dưa muối',
          'Sản xuất mắm cá',
          'Sản xuất mỳ',
          'Siêu thị',
          'Tẩm ướp thuỷ sản',
          'Thái cá sashimi',
          'Thịt bò',
          'Thịt gà',
          'Thịt lợn',
          'Thức ăn cơ sở y tế',
          'Thực phẩm',
          'Thực phẩm sữa',
          'Thực phẩm trứng',
          'Thuỷ sản gia công chế biến',
          'Thuỷ sản khô',
          'Thuỷ sản lên men',
          'Thuỷ sản sấy khô',
          'Thuỷ sản ủ muối',
          'Thuỷ sản xông khói'
      ] },
      { name: 'Sản xuất, dịch vụ tổng hợp', slug: 'san-xuat-dich-vu-tong-hop', termCode: '3261', keywords: [
          'Bảo dưỡng ô tô',
          'Công việc cưa gỗ',
          'Đóng gói',
          'Đóng gói công nghiệp',
          'Đóng gói mỹ phẩm',
          'Đóng sách',
          'Đúc gốm bằng áp lực',
          'Đúc khuôn cao su',
          'Đục lỗ hộp in',
          'Đúc nhựa',
          'Đúc nhựa cán xếp chồng',
          'Đục nhựa ép phun',
          'Đúc nhựa nén',
          'Đúc nhựa thổi định hình',
          'Đúc nhựa thổi phồng',
          'Gia công đồ gia dụng',
          'Gia công ép đùn cao su',
          'Gia công sản phẩm gỗ',
          'Gỗ ép',
          'In gốm',
          'In offset',
          'In ống đồng',
          'In vỏ bánh kẹo',
          'Kiểm tra sản phẩm nhựa',
          'Nặn gốm bằng bánh xoay',
          'Nhiên liệu rắn từ rác',
          'Sản xuất hộp bìa cứng',
          'Sản xuất hộp in',
          'Sản xuất hộp nhãn dán',
          'Sản xuất linh kiện',
          'Sản xuất pin năng lượng',
          'Sản xuất vải lanh',
          'Sửa chữa ô tô',
          'Thiết bị khí nén đường sắt',
          'Trộn và cán cao su',
          'Vật liệu composite nhiều lớp'
      ] },
      { name: 'Điện, điện tử', slug: 'dien-dien-tu', termCode: '33441', keywords: [
          'Bản mạch in',
          'Cuộn dây máy điện quay',
          'Điện',
          'Điện tử',
          'Lắp ráp điện',
          'Lắp ráp điện tử',
          'Lắp ráp linh kiện bán dẫn',
          'Lắp ráp máy biến áp',
          'Lắp ráp thiết bị điện khí',
          'Lắp ráp thiết bị điện quay',
          'Lắp ráp thiết bị điện tử',
          'Lắp thiết bị đóng, mở',
          'Lắp tủ điện, tủ điều khiển',
          'Sản xuất bảng mạch in',
          'Sửa chữa dụng cụ',
          'Sửa chữa tủ điện',
          'Thi công điện',
          'Thiết kế bảng mạch in'
      ] },
      { name: 'Chế tạo Vật liệu', slug: 'che-tao-vat-lieu', termCode: '33281', keywords: [
          'Xử lý nhiệt bề mặt',
          'Xử lý nhiệt một phần',
          'Xử lý nhiệt tổng thể'
      ] },
      { name: 'Cơ khí, chế tạo máy', slug: 'co-khi-che-tao-may', termCode: '332710', keywords: [
          'Bảo trì máy móc',
          'Chế tạo kim loại tấm',
          'Chế tạo máy',
          'Cơ khí',
          'Dập khuôn kim loại',
          'Đóng tàu',
          'Đúc',
          'Đúc gang',
          'Đúc khuôn',
          'Đúc khuôn buồng lạnh',
          'Đúc khuôn buồng nóng',
          'Đúc kim loại màu',
          'Ép dập kim loại',
          'Gia công cơ khí',
          'Gia công ép đùn',
          'Gia công kim loại - Tekko',
          'Gia công tinh',
          'Hàn',
          'Hàn bán tự động',
          'Hàn kết cấu',
          'Hàn khí',
          'Hàn khung thép',
          'Hàn tàu',
          'Hàn thủ công',
          'Hàn tủ điện',
          'Hàn xì',
          'Hoàn thiện dụng cụ nung chảy',
          'Hoàn thiện khuôn',
          'Hoàn thiện sản phẩm ép đùn',
          'Kiểm tra máy móc',
          'Lắp đặt điều hoà',
          'Lắp đặt máy móc',
          'Lắp đặt tủ lạnh',
          'Lắp ráp máy móc',
          'Máy sản xuất tấm kim loại',
          'Rèn',
          'Rèn bằng búa',
          'Sơn',
          'Sơn cầu thép',
          'Sơn công trình xây dựng',
          'Sơn kim loại',
          'Sơn phun',
          'Sử dụng máy phay',
          'Sử dụng máy tiện số',
          'Sử dụng máy tiện thường',
          'Thi công kết cấu thép',
          'Vận hành máy',
          'Vận hành máy CNC',
          'Vận hành máy ép',
          'Vận hành máy ép nhựa',
          'Vận hành robot',
          'Xử lý điện hóa nhôm'
      ] },
      { name: 'Ô tô', slug: 'o-to', termCode: '3363', keywords: [
          'Bảo dưỡng ô tô',
          'Kiểm tra linh kiện ô tô',
          'Lắp ráp linh kiện ô tô',
          'Linh kiện ô tô',
          'Sửa chữa ô tô'
      ] },
      { name: 'Hàng không', slug: 'hang-khong', termCode: '4881', keywords: [
          'hàng không',
          'sân bay',
          'bốc dỡ'
      ] },
      { name: 'Vận tải', slug: 'van-tai', termCode: '484', keywords: [
          'Hậu cần vận tải',
          'Lái xe',
          'Lái xe buýt',
          'Lái xe tải',
          'Phụ xe',
          'Quản lý kho vận tải',
          'Thực tập lái xe'
      ] },
      { name: 'Xây dựng', slug: 'xay-dung', termCode: '23', keywords: [
          'Bê tông',
          'Buộc thép',
          'Chống thấm',
          'Cốp pha công trình',
          'Dán tường',
          'Đổ bê tông áp lực',
          'Đổ nhựa đường',
          'Dựng giàn giáo',
          'Đường ống',
          'Đường ống điều hoà',
          'Đường ống nhà máy',
          'Đường ống nước',
          'Đường ống xây dựng',
          'Gia công đường ống',
          'Gia công khung thép',
          'Gia công khung thép trong xưởng',
          'Gia công sắt trong xưởng',
          'Gia công vật liệu đá',
          'Hàn khung thép trên cao',
          'Hoàn thiện nội thất',
          'Hoàn thiện sàn nhựa',
          'Hoàn thiện sàn thảm',
          'Hoàn thiện ván',
          'Hút nước ngầm công trình',
          'Khoan giếng máy dập',
          'Khoan giếng máy khoan',
          'Khung chắn toà nhà',
          'Lái máy ủi',
          'Lái máy xây dựng',
          'Lái máy xúc',
          'Lái máy xúc lật',
          'Lái xe lu',
          'Làm nền, móng',
          'Lắp bồn tắm',
          'Lắp đặt đường ống',
          'Lắp đặt lò nung-xây dựng',
          'Lắp đặt pin năng lượng',
          'Lắp điện lạnh, điều hòa',
          'Lắp ghép cốt thép',
          'Lát đá',
          'Lợp mái nhà',
          'Lợp ngói',
          'Mộc cốp pha',
          'Nội thất gỗ-xây dựng',
          'Ốp lát gạch',
          'Phá dỡ',
          'San lấp mặt bằng',
          'Sản xuất bê tông',
          'Sơn xây dựng',
          'Tấm kim loại kiến trúc',
          'Tấm kim loại ống gió',
          'Thi công dán tường',
          'Thi công lắp rèm',
          'Thi công móng thép',
          'Thợ mộc xây dựng',
          'Trát vữa',
          'Xây dựng tổng hợp'
      ] },
      { name: 'Vệ sinh toà nhà', slug: 've-sinh-toa-nha', termCode: '561720', keywords: [
          'Buồng phòng khách sạn',
          'Vệ sinh toà nhà'
      ] },
      { name: 'Lưu trú, khách sạn', slug: 'luu-tru-khach-san', termCode: '721110', keywords: [
          '(Khách sạn) Tiếp khách, quản lý vệ sinh',
          'Hành lý khách sạn',
          'Lễ tân khách sạn',
          'Lưu trú khách sạn',
          'Quản lý khách sạn'
      ] },
      { name: 'Điều dưỡng', slug: 'dieu-duong', termCode: '623110', keywords: [
          'điều dưỡng',
          'chăm sóc người già',
          'hộ lý'
      ] }
    ],
    'ky-su-tri-thuc': [
      { name: "Nông lâm ngư nghiệp", slug: "nong-lam-ngu-nghiep", termCode: '11', keywords: [
          "Chăn nuôi",
          "Công nghệ nông, lâm, ngư nghiệp",
          "Công nhân chăn nuôi đặc khu",
          "Công nhân Nông, Lâm, Ngư nghiệp",
          "Công nhân trồng trọt đặc khu"
      ] },
      { name: "Thực phẩm", slug: "thuc-pham", termCode: '311', keywords: [
          "thực phẩm",
          "đồ uống"
      ] },
      { name: "Sản xuất, chế tạo, công nghệ", slug: "san-xuat-cong-nghe", termCode: '31-33', keywords: [
          "Công nghệ môi trường",
          "Công nghệ sản xuất",
          "Công nhân sản xuất, gia công sản phẩm (trừ kim loại, máy móc)",
          "Gia công đồ xa xỉ",
          "Hoá học làm xưởng",
          "In ấn",
          "IT làm xưởng",
          "Khoan khảo sát dầu mỏ, năng lượng",
          "Kinh tế làm xưởng",
          "Lao động nước ngoài lĩnh vực sản xuất",
          "May mặc",
          "Môi trường làm xưởng",
          "Nhân viên sân bay",
          "Quản lý sản xuất tổng hợp",
          "Rác thải, phế liệu, tái chế",
          "Sản xuất sản phẩm",
          "Sản xuất sản phẩm cho nước ngoài",
          "Thiết kế thời trang"
      ] },
      { name: "Cơ khí, máy móc", slug: "co-khi-may-moc", termCode: '332710', keywords: [
          "Bảo trì hệ thống điện",
          "Bảo trì máy móc",
          "Chế tạo máy",
          "Cơ khí",
          "Công nghệ cơ khí",
          "Công nhân đóng tàu nước ngoài",
          "Công nhân sản xuất, gia công kim loại",
          "Điện cơ khí hỗ trợ chuyển nhà",
          "Điện nội thất",
          "Điện, kỹ thuật điện",
          "Gia công cơ khí",
          "Kiểm tra máy móc",
          "Lắp đặt điều hoà",
          "Lắp đặt máy móc",
          "Lắp đặt tủ lạnh",
          "Lắp ráp máy móc",
          "Phân tích CAE",
          "Quản lý sản xuất máy",
          "Thiết kế Auto CAD",
          "Thiết kế cơ khí",
          "Thiết kế điện",
          "Tự động hoá",
          "Vận hành máy",
          "Vận hành máy CNC",
          "Vận hành máy ép",
          "Vận hành máy ép nhựa",
          "Vận hành robot",
          "Viễn thông"
      ] },
      { name: "Công nghệ ô tô", slug: "cong-nghe-o-to", termCode: '81111', keywords: [
          "ô tô",
          "thiết kế ô tô"
      ] },
      { name: "Vận chuyển hàng hóa", slug: "van-chuyen-hang-hoa", termCode: '488510', keywords: [
          "Đại lý thủ tục hàng hải",
          "Quản lý dọn dẹp",
          "Quản lý đóng gói",
          "Quản lý vận chuyển",
          "Quản lý vận chuyển, dọn dẹp, đóng gói"
      ] },
      { name: "Xây dựng", slug: "xay-dung", termCode: '23', keywords: [
          "Cầu đường",
          "Công nghệ xây dựng của nước ngoài",
          "Công nhân kết cấu xây dựng",
          "Công nhân xây dựng (trừ khung công trình)",
          "Công nhân xây dựng mỏ tổng hợp",
          "Công nhân xây dựng nước ngoài",
          "Đường ống",
          "Giám sát thi công",
          "Hoàn thiện nội thất",
          "Khảo sát",
          "Kiến trúc sư",
          "Kỹ thuật Khảo sát",
          "Kỹ thuật Kiến trúc",
          "Kỹ thuật Kiến trúc, Xây dựng, Khảo sát",
          "Kỹ thuật Xây dựng",
          "Nội thất gỗ",
          "Quản lý, giám sát thi công công trình",
          "Trắc địa, khảo sát",
          "Xây dựng dân dụng"
      ] },
      { name: "Khách sạn, lưu trú", slug: "khach-san-luu-tru", termCode: '721110', keywords: [
          "Dịch vụ khách sạn",
          "Khu nghỉ dưỡng",
          "Lễ tân khách sạn"
      ] },
      { name: "Y tế, điều dưỡng", slug: "y-te-dieu-duong", termCode: '62', keywords: [
          "Bác sĩ",
          "Bác sĩ chỉnh thị lực",
          "Chuyên viên phục hình",
          "Điều dưỡng có chứng chỉ",
          "Điều dưỡng dự bị học EPA",
          "Điều dưỡng, hộ lý EPA",
          "Điều dưỡng, hộ lý EPA dự bị",
          "Dược sĩ",
          "Kỹ thuật viên X quang",
          "Nha sĩ",
          "Nhà trị liệu nghề nghiệp",
          "Nữ hộ sinh",
          "Trợ lý y tá",
          "Vật lý trị liệu",
          "Vệ sinh răng miệng",
          "Y tá",
          "Y tá EPA",
          "Y tá EPA dự bị",
          "Y tá sức khoẻ cộng đồng",
          "Y tế lâm sàng"
      ] },
      { name: "Kinh doanh, kinh tế", slug: "kinh-doanh-kinh-te", termCode: '541611', keywords: [
          "Bán hàng miễn thuế",
          "Dịch vụ bán hàng",
          "Dịch vụ khách hàng tổng hợp",
          "Điều hành",
          "Hoạt động khởi nghiệp",
          "Kinh doanh kế toán",
          "Kinh tế",
          "Nghiên cứu thị trường, marketing",
          "Nhân viên dịch vụ khác (không phân loại nơi khác)",
          "Quản lý",
          "Quản lý kế hoạch quảng cáo, truyền thông",
          "Thương mại nước ngoài",
          "Tiếp thị (sales) doanh nghiệp"
      ] },
      { name: "Tài chính, kế toán, bảo hiểm", slug: "tai-chinh-ke-toan-bao-hiem", termCode: '52', keywords: [
          "Kế toán công chứng",
          "Kế toán công chứng nước ngoài",
          "Kế toán thuế",
          "Tài chính, bảo hiểm",
          "Tư vấn bảo hiểm xã hội"
      ] },
      { name: "Báo chí, truyền thông, marketing", slug: "bao-chi-truyen-thong-marketing", termCode: '51', keywords: [
          "Báo chí",
          "Biên tập",
          "Digital Marketing",
          "Marketing",
          "Nhà báo",
          "Thiết kế Marketing",
          "Truyền thông",
          "Viết quảng cáo"
      ] },
      { name: "Công nghệ thông tin", slug: "it", termCode: '541511', keywords: [
          "Công nghệ thông tin",
          "IT",
          "lập trình",
          "phần mềm",
          "Blockchain",
          "BrSE (Bridge System Engineer)",
          "Business Analyst (BA)",
          "COO (Chief Operation Officer)",
          "CTO (Chief Technology Officer)",
          "ITM (Information Technical Manager)",
          "Lập trình nhúng",
          "Lập trình viên",
          "PM (Product Manager)",
          "PO (Product Owner)",
          "Tester",
          "Thiết kế UI, UX",
          "Trí tuệ nhân tạo",
          "Vận hành web thương mại điện tử"
      ] },
      { name: "Nghiên cứu, phân tích", slug: "nghien-cuu-phan-tich", termCode: '5417', keywords: [
          "Khảo sát đất đai, nhà ở",
          "Nghiên cứu",
          "Nghiên cứu thị trường"
      ] },
      { name: "Giáo dục, đào tạo", slug: "giao-duc-dao-tao", termCode: '61', keywords: [
          "Giảng dạy có chứng chỉ",
          "Giảng dạy đại học",
          "Giảng dạy ngoài cơ sở giáo dục",
          "Giảng dạy ngôn ngữ tại Tiểu học, THCS, PTTH",
          "Giảng dạy trường dạy nghề (Senmon)",
          "Giảng dạy trường học các loại",
          "Giảng dạy trường quốc tế",
          "Hướng dẫn nghiên cứu",
          "Hướng dẫn thể thao"
      ] },
      { name: "Hành chính, văn phòng", slug: "hanh-chinh-van-phong", termCode: '561110', keywords: [
          "Biên dịch, phiên dịch",
          "Nhân viên văn phòng"
      ] },
      { name: "Pháp lý", slug: "phap-ly", termCode: '5411', keywords: [
          "pháp lý",
          "luật sư"
      ] },
      { name: "Nghệ thuật, nghệ sĩ", slug: "nghe-thuat", termCode: '711510', keywords: [
          "Mỹ thuật gia",
          "nhiếp ảnh gia",
          "Nhà văn",
          "Nhạc sĩ",
          "nghệ sĩ sân khấu"
      ] },
      { name: "Thể dục thể thao", slug: "the-thao", termCode: '71121', keywords: [
          "Vận động viên chuyên nghiệp",
          "Vận động viên nghiệp dư"
      ] },
      { name: "Nghề có kỹ năng chuyên nghiệp", slug: "nghe-chuyen-nghiep", termCode: '812990', keywords: [
          "Công chức",
          "Giúp việc gia đình đặc khu",
          "Huấn luyện động vật",
          "Nấu nướng",
          "Người pha chế rượu",
          "Người quản gia",
          "Nhà ngoại giao",
          "Nhân viên tôn giáo",
          "Phi công"
      ] },
      { name: "Việc làm bán chuyên nghiệp", slug: "viec-lam-ban-chuyen-nghiep", termCode: '611630', keywords: [
          "Công việc mùa hè",
          "Lao động kỳ nghỉ",
          "Sinh viên thực tập",
          "Trao đổi văn hóa quốc tế"
      ] }
    ]
};

export const allIndustries: Industry[] = Array.from(new Map(Object.values(industriesByJobType).flat().map(item => [item.slug, item])).values());

export const industryGroups = {
  'Công xưởng': ['Chế biến thực phẩm', 'Cơ khí', 'Điện tử', 'Dệt may', 'May mặc', 'Cơ khí, kim loại', 'Cơ khí, chế tạo máy', 'Điện, điện tử'],
  'Ngoài trời': ['Xây dựng', 'Nông nghiệp', 'Ngư nghiệp'],
  'Dịch vụ & Chăm sóc con người': ['Điều dưỡng', 'Nhà hàng', 'Vận tải', 'Lưu trú, khách sạn', 'Vệ sinh toà nhà', 'Hàng không'],
};


export const jobInfoContents: { [key: string]: any } = {
  'Nhóm ngành 1': {
    title: 'Cơ khí – Nhóm ngành 1 (機械金属加工区分 / Kikai Kinzoku Kakō Kubun)',
    industries: [
      { vi: 'Đúc kim loại', ja: '鋳造', ro: 'Chūzō' },
      { vi: 'Đúc khuôn', ja: 'ダイカスト', ro: 'Daikasuto' },
      { vi: 'Dập kim loại', ja: '金属プレス', ro: 'Kinzoku puresu' },
      { vi: 'Kim loại tấm', ja: '工場板金', ro: 'Kōjō bankin' },
      { vi: 'Rèn', ja: '鍛造', ro: 'Tanzō' },
      { vi: 'Chế tạo vật liệu thép', ja: '鉄工', ro: 'Tekko' },
      { vi: 'Gia công cơ khí', ja: '機械加工', ro: 'Kikai kakō' },
      { vi: 'Gia công tinh/ gia công hoàn thiện', ja: '仕上げ加工', ro: 'Shiage kako' },
      { vi: 'Đúc nhựa', ja: 'プラスチック成形', ro: 'Purasuchikku seikei' },
      { vi: 'Hàn', ja: '溶接', ro: 'Yōsetsu' },
      { vi: 'Sơn', ja: '塗装', ro: 'Tosō' },
      { vi: 'Điện khí', ja: '電気機器組み立て', ro: 'Denki kiki kumitate' },
      { vi: 'Kiểm tra máy', ja: '機械検査', ro: 'Kikai kensa' },
      { vi: 'Bảo dưỡng máy', ja: '機械保全', ro: 'Kikai hozen' },
      { vi: 'Đóng gói công nghiệp', ja: '工業包装', ro: 'Kōgyō hōsō' },
    ],
  },
  'Nhóm ngành 2': {
    title: 'Cơ khí, điện tử – Nhóm ngành 2 (電気電子機器組立て区分 / Denki Denshi Kiki Kumitate Kubun)',
    industries: [
      { vi: 'Gia công cơ khí', ja: '機械加工', ro: 'Kikai kakō' },
      { vi: 'Gia công tinh/ gia công hoàn thiện', ja: '仕上げ加工', ro: 'Shiage kako' },
      { vi: 'Đúc nhựa', ja: 'プラスチック成形', ro: 'Purasuchikku seikei' },
      { vi: 'Điện khí', ja: '電気機器組み立て', ro: 'Denki kiki kumitate' },
      { vi: 'Điện tử', ja: '電子機器組み立て', ro: 'Denshi kiki kumitate' },
      { vi: 'Bảng mạch in', ja: 'プリント配線板', ro: 'Purinto haisenban' },
      { vi: 'Kiểm tra máy', ja: '機械検査', ro: 'Kikai kensa' },
      { vi: 'Bảo dưỡng máy', ja: '機械保全', ro: 'Kikai hozen' },
      { vi: 'Đóng gói công nghiệp', ja: '工業包装', ro: 'Kōgyō hōsō' },
    ],
  },
  'Nhóm ngành 3': {
    title: 'Cơ khí - Nhóm ngành 3 - Xử lý bề mặt kim loại (金属表面処理区分 / Kinzoku Hyōmen Shori Kubun)',
    industries: [
      { vi: 'Mạ', ja: 'めっき', ro: 'Mekki' },
      { vi: 'Mạ nhôm (Anode nhôm)', ja: 'アルミニウム陽極酸化処理', ro: 'Aruminiumu yōkyoku sanka shori' },
    ],
  },
  'Nhóm ngành xây dựng 1': {
    title: 'Xây dựng - Nhóm ngành 1 (Công trình dân dụng / Doboku)',
    industries: [
      { vi: 'Khoan giếng (Percussion)', ja: 'パーカッション式さく井工事作業', ro: 'Paakasshon-shiki saku i kōji sagyō' },
      { vi: 'Khoan giếng (Rotary)', ja: 'ロータリー式さく井工事作業', ro: 'Rōtarī-shiki saku i kōji sagyō' },
      { vi: 'Thi công ván khuôn', ja: '型枠工事作業', ro: 'Katawaku kōji sagyō' },
      { vi: 'Thi công cốt thép', ja: '鉄筋組立て作業', ro: 'Tekkin kumitate sagyō' },
      { vi: 'Giàn giáo', ja: 'とび作業', ro: 'Tobi sagyō' },
      { vi: 'Bơm ép bê tông', ja: 'コンクリート圧送工事作業', ro: 'Konkuriito assō kōji sagyō' },
      { vi: 'Thi công Wellpoint', ja: 'ウェルポイント工事作業', ro: 'Werupointo kōji sagyō' },
      { vi: 'Máy xây dựng - San ủi / San nền', ja: '押土・整地作業', ro: 'Osudo / seichi sagyō' },
      { vi: 'Máy xây dựng - Bốc xếp', ja: '積込み作業', ro: 'Tsumikomi sagyō' },
      { vi: 'Máy xây dựng - Đào xúc', ja: '掘削作業', ro: 'Kussaku sagyō' },
      { vi: 'Máy xây dựng - Đầm nén', ja: '締固め作業', ro: 'Shimekatame sagyō' },
      { vi: 'Gia công kết cấu thép', ja: '構造物鉄工作業', ro: 'Kōzōbutsu tekkō sagyō' },
      { vi: 'Sơn xây dựng', ja: '建築塗装作業', ro: 'Kenchiku tosō sagyō' },
      { vi: 'Sơn cầu thép', ja: '鋼橋塗装作業', ro: 'Kōkyō tosō sagyō' },
      { vi: 'Hàn thủ công', ja: '手溶接', ro: 'Te yōsetsu' },
      { vi: 'Hàn bán tự động', ja: '半自動溶接', ro: 'Han jidō yōsetsu' },
    ],
  },
  'Nhóm ngành xây dựng 2': {
    title: 'Xây dựng - Nhóm ngành 2 (Công trình kiến trúc / Kenchiku)',
    industries: [
      { vi: 'Tôn mái, ốp kim loại', ja: '内外装板金作業', ro: 'Naigaisō bankin sagyō' },
      { vi: 'Ống gió, ống dẫn', ja: 'ダクト板金作業', ro: 'Dakuto bankin sagyō' },
      { vi: 'Chế tác cửa gỗ', ja: '木製建具手加工作業', ro: 'Mokusei tategu te kako sagyō' },
      { vi: 'Mộc xây dựng', ja: '大工工事作業', ro: 'Daiku kōji sagyō' },
      { vi: 'Thi công ván khuôn', ja: '型枠工事作業', ro: 'Katawaku kōji sagyō' },
      { vi: 'Thi công cốt thép', ja: '鉄筋組立て作業', ro: 'Tekkin kumitate sagyō' },
      { vi: 'Giàn giáo', ja: 'とび作業', ro: 'Tobi sagyō' },
      { vi: 'Gia công đá', ja: '石材加工作業', ro: 'Sekizai kakō sagyō' },
      { vi: 'Ốp lát đá', ja: '石張り作業', ro: 'Ishibari sagyō' },
      { vi: 'Ốp lát gạch', ja: 'タイル張り作業', ro: 'Tairu bari sagyō' },
      { vi: 'Lợp ngói', ja: 'かわらぶき作業', ro: 'Kawarabuki sagyō' },
      { vi: 'Trát vữa', ja: '左官作業', ro: 'Sakan sagyō' },
      { vi: 'Hoàn thiện nội thất - Sàn nhựa', ja: 'プラスチック系床仕上げ工事作業', ro: 'Purasuchikku-kei yuka shiage kōji sagyō' },
      { vi: 'Hoàn thiện nội thất - Sàn thảm', ja: 'カーペット系床仕上げ工事作業', ro: 'Kāpetto-kei yuka shiage kōji sagyō' },
      { vi: 'Hoàn thiện nội thất - Khung thép', ja: '鋼製下地工事作業', ro: 'Kōsei shitaji kōji sagyō' },
      { vi: 'Hoàn thiện nội thất - Tấm trần', ja: 'ボード仕上げ工事作業', ro: 'Bōdo shiage kōji sagyō' },
      { vi: 'Hoàn thiện nội thất - Rèm cửa', ja: 'カーテン工事作業', ro: 'Kāten kōji sagyō' },
      { vi: 'Trang trí tường (giấy dán)', ja: '壁装作業', ro: 'Hekisō sagyō' },
      { vi: 'Thi công cửa nhôm kính', ja: 'ビル用サッシ施工作業', ro: 'Biru-yō sasshi seko sagyō' },
      { vi: 'Chống thấm', ja: 'シーリング防水工事作業', ro: 'Shīringu bōsui kōji sagyō' },
      { vi: 'Bơm ép bê tông', ja: 'コンクリート圧送工事作業', ro: 'Konkuriito assō kōji sagyō' },
      { vi: 'Xây lò công nghiệp', ja: '築炉作業', ro: 'Chikuro sagyō' },
    ],
  },
  'Nhóm ngành xây dựng 3': {
    title: 'Xây dựng - Nhóm ngành 3 - Hệ thống hạ tầng và thiết bị (ライフライン・設備 / Raifurain / Setsubi)',
    industries: [
      { vi: 'Tôn mái, ốp kim loại', ja: '内外装板金作業', ro: 'Naigaisō bankin sagyō' },
      { vi: 'Ống gió, ống dẫn', ja: 'ダクト板金作業', ro: 'Dakuto bankin sagyō' },
      { vi: 'Lắp đặt máy lạnh - điều hòa', ja: '冷凍空気調和機器施工作業', ro: 'Reitō kūki chōwa kiki seko sagyō' },
      { vi: 'Lắp đặt đường ống xây dựng', ja: '建築配管作業', ro: 'Kenchiku haikan sagyō' },
      { vi: 'Lắp đặt đường ống nhà máy', ja: 'プラント配管作業', ro: 'Puranto haikan sagyō' },
      { vi: 'Cách nhiệt - bảo ôn', ja: '保温保冷工事作業', ro: 'Ho-on horei kōji sagyō' },
      { vi: 'Hàn thủ công', ja: '手溶接', ro: 'Te yōsetsu' },
      { vi: 'Hàn bán tự động', ja: '半自動溶接', ro: 'Han jidō yōsetsu' },
    ],
  },
};